export enum State{
  New,
  Unchanged,
  Changed,
  Removed
}
